import { SkeletonLoader } from '@design';
import clsx from 'clsx';
import React from 'react';

import { TitleItem } from '../../utils';
import styles from './ListTitleItem.module.scss';

export interface ListTitleItemProps {
  item: TitleItem;
  variant: 'default' | 'secondary';
}

export const ListTitleItem = ({ item, variant }: ListTitleItemProps) => {
  if (!item.title) {
    return null;
  }

  return (
    <button
      className={styles.titleAndDividerWrapper}
      data-testid="list-title-item-root"
    >
      <div className={styles.hideOrShowButtonWrapper}>
        <p
          className={clsx(styles.listTitle, {
            [styles.secondary]: variant === 'secondary',
          })}
          data-testid={item.title}
        >
          {item.title}
        </p>
      </div>
      {variant === 'secondary' && <div className={styles.horizontalDivider} />}
      {item.loading && (
        <div className={styles.skeletonLoaderWrapper}>
          <SkeletonLoader
            areas={[
              {
                styles: {
                  height: '20px',
                  borderRadius: '8px',
                },
              },
            ]}
          />
        </div>
      )}
    </button>
  );
};
